import { render, staticRenderFns } from "./fccRequisicaoDadosCadastrais.vue?vue&type=template&id=b1b13e0c"
import script from "./fccRequisicaoDadosCadastrais.vue?vue&type=script&lang=js"
export * from "./fccRequisicaoDadosCadastrais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports